import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const MockExamTemplateRepository = RepositoryFactory.get("mockExamTemplates");

const state = {
  mock_exams_meta: {},
  mock_exam_template: {},
};

const actions = {
  create({ dispatch }, payload) {
    dispatch("loadings/enableLoadings", {}, { root: true });
    return MockExamTemplateRepository.create(payload)
      .then(() => {
        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(`message.notifications.mockExams.importSuccess`),
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(`message.notifications.mockExams.importError`),
          },
          { root: true },
        );

        throw error;
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  teacherList({ dispatch, commit }, locale) {
    let payload = {
      locale: locale,
    };
    dispatch("loadings/enableLoadings", {}, { root: true });
    MockExamTemplateRepository.teacherList(payload)
      .then((response) => {
        commit("SAVE_MOCK_EXAMS_META", response.data);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.mockExams.getMockExamsTableOfContentsError`,
            ),
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  getMockExamForTeacher({ commit, dispatch }, mockExamId) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    return MockExamTemplateRepository.getMockExamForTeacher(mockExamId)
      .then((response) => {
        let mockExamTemplate = response.data;
        commit("SAVE_MOCK_EXAM_TEMPLATE", mockExamTemplate);
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
};

const mutations = {
  SAVE_MOCK_EXAM_TEMPLATE(state, mockExamTemplate) {
    state.mock_exam_template = mockExamTemplate;
  },
  SAVE_MOCK_EXAMS_META(state, mock_exams_meta) {
    state.mock_exams_meta = mock_exams_meta;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
};
